<script context="module">
  let current;
</script>

<script>
  import { _ as t } from "svelte-i18n";
  import { get } from "svelte/store";
  import { Icon } from "t2c-components";
  export let menu;
  export let right = undefined;
  export let icon = "menu";
  export let text = null;
  export let selectedItem = null;

  let active = false;
  let dropdown;

  const handleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    active = !active;
    if (active) {
      stopOthers();
    } else {
      current = undefined;
    }
  };

  export const handleClose = (e) => {
    active = false;
    current = undefined;
  };

  const stopOthers = () => {
    if (current && current !== dropdown) {
      current.click();
    }
    current = dropdown;
  };
</script>

<svelte:window on:click={handleClose} />
<button
  class="dropdown"
  class:button={!!text}
  on:click={handleExpand}
  bind:this={dropdown}
>
  <div class="button">
    <Icon medium {icon} />
    {#if text}
      {text}
    {/if}
  </div>
  <div class="dropdown-content" class:right class:active>
    {#each menu as item}
      <div
        class="context-item"
        class:selected={item.key ? item.key === selectedItem : false}
        on:click={item.handleClick}
      >
        <Icon medium icon={item.icon} />
        <div>{item.textKey ? $t(item.textKey) : item.text}</div>
      </div>
    {/each}
  </div>
</button>

<style>
  .dropdown {
    position: relative;
    display: inline-block;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  .dropdown.button {
    padding: 8px 14px;
    padding-right: 20px;
  }

  .dropdown:hover {
    background-color: #eee;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 320px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 8px;
    z-index: 1;
    top: 32px;
    right: 0;
  }

  .dropdown-content.right {
    left: 0;
    right: auto;
  }

  .dropdown-content.active {
    display: block;
  }

  .context-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
  }

  .context-item.selected {
    border-left: 2px solid var(--accent);
  }

  .context-item:hover {
    background-color: #eee;
  }

  .button {
    display: flex;
    align-items: center;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08rem;
  }
</style>
